import { inject, injectable } from 'inversify';
import { Store } from 'vuex';
import { DEPENDENCIES } from '../container/dependencies.const';
import { EmpathyXConfig } from '../models';
import { GETTERS_KEYS, RootStoreState } from '../store';
import { ProductPageService } from './services.types';

@injectable()
export class UrlParamProductPageService implements ProductPageService {

  @inject(DEPENDENCIES.Store)
  private readonly store: Store<RootStoreState>;

  getResultId(): string {
    const resultIdParamName = (this.store.getters[GETTERS_KEYS.config.config] as EmpathyXConfig).tracking.addToCart.resultIdUrlParamName;
    return new URL(window.location.href).searchParams.get(resultIdParamName);
  }

}
